/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import Footer from '@consteed/overrides/theme/components/project/footer'

const {baseStyle} = Footer

export default {
    parts: ['container', 'content', 'paymentIconsContainer', 'creditCardIcon', 'linksList'],
    baseStyle: {
        container: baseStyle.container,
        content: baseStyle.content,
        paymentIconsContainer: {
            justifyContent: {md: 'end'}
        },
        creditCardIcon: {
            width: '38px',
            height: '22px'
        },
        linksList: {
            display: 'flex',
            justifyContent: {md: 'end'},
            marginBottom: {base: 10, md: 0}
        }
    }
}
